import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { ContainedRoundedButton } from "../../components/styled/buttons/SecondaryRoundedButton";
import Svg from "../../components/ui library/components/svgs/standard/svg";
import HNSColors from "../../components/ui library/HNSColors";

const Template = () => {
  const navigate = useNavigate();
  return (
    <Box className="flex h-[80vh] flex-col items-center justify-center p-10">
      <div className="mb-6 flex w-full max-w-2xl justify-center">
        <Svg
          name="his-error-sign"
          sx={{
            minWidth: "400px",
            maxWidth: "540px",
            maxHeight: "381px",
            height: "auto",
          }}
          color={HNSColors.secondary[500]}
        />
      </div>
      <h1
        className="mb-4 text-center text-2xl font-semibold leading-tight sm:text-3xl md:text-4xl lg:text-5xl"
        style={{ color: HNSColors.primary[500], fontFamily: "Roboto Slab" }}
      >
        Ooops! Page Not Found
      </h1>

      <p className="mb-8 text-center leading-relaxed">
        The page you are looking for doesn't exist or has been moved.
      </p>

      <div className="flex justify-center">
        <ContainedRoundedButton onClick={() => navigate("/landing")} className="w-auto px-8">
          Go Back
        </ContainedRoundedButton>
      </div>
    </Box>
  );
};

export default Template;
